import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=02b45e54&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=02b45e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b45e54",
  null
  
)

export default component.exports